import { Badge, BadgeProps, styled } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

export interface PoolBadgeProps extends BadgeProps {
    children?: ReactNode;
}

const StandaloneBadge = styled(Badge)(({ theme }) => ({
    height: 24,
    minWidth: 24,

    '& .MuiBadge-badge': {
        ...theme.typography.caption,
        fontWeight: 600,
        right: 'auto',
        top: 'auto',
        position: 'unset',
        transform: 'unset',
        height: 24,
        minWidth: 24,
        borderRadius: 24,
    },
}));

/**
 * PoolBadge<br>
 * <a href="https://www.figma.com/file/kjfAT06qgLdW52cF1SqWuy/Pool-Alpin-Shop-2.0-Library?node-id=412%3A9478" target="_blank">Open Badge in Figma</a><br>
 * <a href="https://www.figma.com/file/kjfAT06qgLdW52cF1SqWuy/Pool-Alpin-Shop-2.0-Library?node-id=446%3A11058" target="_blank">Open Special Buttons in Figma</a>
 */
export const PoolBadge = (props: PoolBadgeProps): ReactElement => {
    const { children, ...badgeProps } = props;

    return children ? (
        <Badge color="primary" {...badgeProps}>
            {children}
        </Badge>
    ) : (
        <StandaloneBadge color="primary" {...badgeProps} />
    );
};
